import { Box, Unstable_Grid2 as Grid, Link, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

export default function Footer() {
	return (
		<Box id="#footer" sx={{ backgroundColor: grey[900], color: grey[50] }}>
			<Grid container spacing={4} sx={{ width: '80dvw', mx: 'auto', py: 4 }}>
				<Grid item lg={2} sx={{ display: 'flex', alignItems: 'center' }}>
					<img
						src="/assets/ib_logo.png"
						style={{ filter: 'drop-shadow(0 0 24px #fff)' }}
						alt="ideabreed"
					/>
				</Grid>
				<Grid item lg={4}>
					<Typography variant="h5" mb={3}>
						Idea Breed IT Solutions Pvt. Ltd.
					</Typography>
					<Typography variant="body1" sx={{ color: grey[400] }}>
						At Idea Breed, we have a passion for turning ideas into reality. Our
						world-class team is fluent in Ruby on Rails, React, React Native,
						iOS, Flutter, Android, and we’re ready to design, build, and train
						so your product is rock-solid and user-friendly.
					</Typography>
				</Grid>
				<Grid item lg={3}>
					<Typography variant="h6" mb={2}>
						USEFUL LINKS
					</Typography>
					<Link href="#" sx={{ display: 'block', color: grey[300] }}>
						Home
					</Link>
					<Link
						href="https://ideabreed.com.np"
						sx={{ display: 'block', color: grey[300] }}
					>
						About Us
					</Link>
					<Link
						href="https://ideabreed.com.np/#services"
						sx={{ display: 'block', color: grey[300] }}
					>
						Services
					</Link>
					<Link
						href="https://ideabreed.com.np/our_products"
						sx={{ display: 'block', color: grey[300] }}
					>
						Our Products
					</Link>
				</Grid>
				<Grid item lg={3}>
					<Typography variant="h6" mb={2}>
						CONTACT US
					</Typography>
					<Typography variant="body1" sx={{ color: grey[300] }}>
						Sanepa, Lalitpur
					</Typography>
					<Typography variant="body1" sx={{ color: grey[300] }}>
						Bagmati, Nepal
					</Typography>
					<Typography variant="body1" sx={{ color: grey[300] }}>
						Phone: 9851266268
					</Typography>
					<Typography variant="body1" sx={{ color: grey[300] }}>
						Email: ideabreed@gmail.com
					</Typography>
					<Typography variant="body1" sx={{ color: grey[300], ml: 6 }}>
						info@ideabreed.net
					</Typography>
				</Grid>
			</Grid>
		</Box>
	);
}
